import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';

export type CheckAuthPasswordParams = WithParams<{
  mobile_number: string;
}>;

export type VerifyAuthPasswordParams = WithParams<{
  mobile_number: string;
  password: string;
}>;

export class AuthPasswordApi {
  static check = async (params: CheckAuthPasswordParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/auth/password/check`, snakes(params));
  };

  static verify = async (params: VerifyAuthPasswordParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/auth/password/verify`, snakes(params))
      .then((response) => humps(response.data) as { accessToken: string });
  };
}
